export const createQueryParam = (
  values?: Record<string, string | number | undefined>,
) => {
  if (!values) return '';
  return Object.keys(values).reduce((result, key) => {
    return appendQueryParam(result, key, values[key]);
  }, '');
};

export const appendQueryParam = (
  s: string,
  name?: string,
  value?: string | number,
) => {
  if (!name || !value) return s;
  if (!s.length) return `?${name}=${value}`;
  return `${s}&${name}=${value}`;
};

export default createQueryParam;
